import React, { FunctionComponent } from "react";

import {
  SiteConfig_siteConfig_notificationsConf,
} from "graphql/generated";

import LegacyNotifications from "./Notifications";


interface IProps {
  siteId: string;
  notificationsConf: SiteConfig_siteConfig_notificationsConf;
  timezone: string;
}


const Notifications: FunctionComponent<IProps> = ({
  notificationsConf,
  siteId,
  timezone,
}) => {
  return (
    <>
      <LegacyNotifications
        notificationsConf={notificationsConf}
        timezone={timezone}
        siteId={siteId}
      />
    </>
  );
};

export default Notifications;
